import { render } from "./NotFoundContent.vue?vue&type=template&id=3f56fcb6&scoped=true"
import script from "./NotFoundContent.vue?vue&type=script&lang=js"
export * from "./NotFoundContent.vue?vue&type=script&lang=js"

import "./NotFoundContent.vue?vue&type=style&index=0&id=3f56fcb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f56fcb6"]])

export default __exports__